import { useEffect } from 'react'

const useOutsideClick = (
  ref: { current: { contains: (arg0: any) => any } },
  callback: () => void,
  optContainer: HTMLElement | Document = document
) => {
  const handleClick = (e: { target: any }) => {
    if (
      ref.current &&
      (optContainer.contains(e.target) || !document.contains(e.target)) &&
      !ref.current.contains(e.target)
    ) {
      callback()
    }
  }

  useEffect(() => {
    document.addEventListener('click', handleClick)

    return () => {
      document.removeEventListener('click', handleClick)
    }
  })
}

export default useOutsideClick
